<p-card [style]="{ margin: 0, height: '100%' }">
  <div class="flex align-items-center gap-2 mb-3">
    <i class="pi pi-bolt text-xl"></i>
    <h2 class="m-0">Monitoring des Webhooks</h2>
  </div>

  <!-- Filtres -->
  <div class="flex gap-2 mb-3 flex-wrap">
    <input
      pInputText
      [(ngModel)]="filterProvider"
      placeholder="Fournisseur (ex: tablot)"
      class="filter-input"
      (keyup.enter)="onFilter()"
    />
    <p-dropdown
      [options]="statusOptions"
      [(ngModel)]="filterStatus"
      optionLabel="label"
      optionValue="value"
      (onChange)="onFilter()"
      [style]="{ minWidth: '180px' }"
    ></p-dropdown>
    <input
      pInputText
      [(ngModel)]="filterSearch"
      placeholder="Recherche (événement, ID externe…)"
      class="filter-input"
      (keyup.enter)="onFilter()"
    />
    <p-button
      icon="pi pi-search"
      label="Filtrer"
      (onClick)="onFilter()"
      severity="secondary"
    ></p-button>
    <p-button
      icon="pi pi-refresh"
      label="Actualiser"
      (onClick)="loadWebhooks()"
      severity="secondary"
      [outlined]="true"
    ></p-button>
  </div>

  <p-table
    [value]="(webhooks$ | async) || []"
    [loading]="(loading$ | async) ?? false"
    [lazy]="true"
    [paginator]="true"
    [rows]="15"
    [rowsPerPageOptions]="[15, 30, 50]"
    [totalRecords]="(total$ | async) || 0"
    (onLazyLoad)="onLazyLoad($event)"
    styleClass="p-datatable-sm"
  >
    <ng-template pTemplate="header">
      <tr>
        <th>#</th>
        <th>Fournisseur</th>
        <th>Événement</th>
        <th>ID externe</th>
        <th>Statut</th>
        <th>Reçu le</th>
        <th>Traité le</th>
        <th></th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-event>
      <tr>
        <td>{{ event.id }}</td>
        <td>
          <code>{{ event.provider }}</code>
        </td>
        <td>
          <span [pTooltip]="event.eventName" tooltipPosition="top">
            {{ event.eventName ?? '—' }}
          </span>
        </td>
        <td>
          <code class="text-xs">{{ event.externalEventId ?? '—' }}</code>
        </td>
        <td>
          <p-tag
            [value]="getStatusLabel(event.status)"
            [severity]="getStatusSeverity(event.status)"
          ></p-tag>
        </td>
        <td>{{ event.createdAt | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
        <td>
          {{
            event.processedAt
              ? (event.processedAt | date: 'dd/MM/yyyy HH:mm:ss')
              : '—'
          }}
        </td>
        <td>
          <p-button
            icon="pi pi-eye"
            [text]="true"
            size="small"
            pTooltip="Voir le détail"
            tooltipPosition="left"
            (onClick)="openDetail(event)"
          ></p-button>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="8" class="text-center text-color-secondary py-4">
          <i class="pi pi-inbox mr-2"></i>
          Aucun webhook reçu
        </td>
      </tr>
    </ng-template>
  </p-table>
</p-card>

<!-- Dialogue de détail -->
<p-dialog
  header="Détail du webhook"
  [(visible)]="detailVisible"
  [modal]="true"
  [style]="{ width: '70vw', maxHeight: '85vh' }"
  [draggable]="false"
  [resizable]="false"
  (onHide)="closeDetail()"
>
  @if (detailLoading$ | async) {
    <div class="flex justify-content-center py-4">
      <i class="pi pi-spin pi-spinner text-2xl"></i>
    </div>
  } @else {
    @if (selectedWebhook$ | async; as detail) {
    <div class="detail-grid">
      <div class="detail-row">
        <span class="detail-label">Fournisseur</span>
        <code>{{ detail.provider }}</code>
      </div>
      <div class="detail-row">
        <span class="detail-label">Événement</span>
        <span>{{ detail.eventName ?? '—' }}</span>
      </div>
      <div class="detail-row">
        <span class="detail-label">ID externe</span>
        <code>{{ detail.externalEventId ?? '—' }}</code>
      </div>
      <div class="detail-row">
        <span class="detail-label">Statut</span>
        <p-tag
          [value]="getStatusLabel(detail.status)"
          [severity]="getStatusSeverity(detail.status)"
        ></p-tag>
      </div>
      @if (detail.errorMessage) {
        <div class="detail-row">
          <span class="detail-label">Erreur</span>
          <span class="error-message">{{ detail.errorMessage }}</span>
        </div>
      }
      <div class="detail-row">
        <span class="detail-label">Reçu le</span>
        <span>{{ detail.createdAt | date: 'dd/MM/yyyy HH:mm:ss' }}</span>
      </div>
      @if (detail.processedAt) {
        <div class="detail-row">
          <span class="detail-label">Traité le</span>
          <span>{{ detail.processedAt | date: 'dd/MM/yyyy HH:mm:ss' }}</span>
        </div>
      }
      @if (detail.externalOccurredAt) {
        <div class="detail-row">
          <span class="detail-label">Date externe</span>
          <span>{{
            detail.externalOccurredAt | date: 'dd/MM/yyyy HH:mm:ss'
          }}</span>
        </div>
      }
    </div>

    @if (detail.payload) {
      <div class="mt-3">
        <h4 class="mb-1">Payload</h4>
        <pre class="json-block">{{ formatJson(detail.payload) }}</pre>
      </div>
    }

    @if (detail.headers) {
      <div class="mt-3">
        <h4 class="mb-1">En-têtes</h4>
        <pre class="json-block headers-block">{{
          formatJson(detail.headers)
        }}</pre>
      </div>
    }
  }
}
</p-dialog>
